import Vue from 'vue'
import Vuex from 'vuex'
import button from './modules/button'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    button
  }
})
